import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReportTable from "../../../components/report/report-table";
import ScoreView from "../../../components/UI/ScoreView";
import * as configActions from "../../../store/config/actions";
import "./style.scss";
import { useDispatch } from "react-redux";
import Notation from "../../../components/report/notation";
import { handleCompPerformance } from "../../../helpers";
import SubjectwiseReport from './SubjectwiseReport';
import { textIdentifier } from "../../../textIdentifier";

export default function SubTopicWiseReport({}) {
  const { selectedCompetition, selectedSchool,lang } = useSelector(
    (state) => state.main
  );
  const navigate = useNavigate();
  const [values, setValues] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const dispatch = useDispatch();

  const fetchData = async () => {
    try {
      selectedSchool.subTopicData.map((item, i) => {
        const competition_subTopic =
          selectedCompetition.subTopicsWiseReportData.find(
            (data) => data.id === item.id
          );
        item.competition_proficiency = competition_subTopic.proficiency;
        item.competition_accuracy = competition_subTopic.accuracy;
        item.competition_marks = competition_subTopic.marks;

        item.proficiency_status = handleCompPerformance(
          item.proficiency,
          competition_subTopic.proficiency
        );
        item.accuracy_status = handleCompPerformance(
          item.accuracy,
          competition_subTopic.accuracy
        );
        item.marks_status = handleCompPerformance(
          item.marks,
          competition_subTopic.marks
        );

        return item;
      });
      setValues(selectedSchool.subTopicData);
    } catch (error) {
      dispatch(configActions.showAlert(error?.data?.message));
    } finally {
      setIsFetching(false);
    }
  };

  const handleFloatParse = (val) => {
    // return parseFloat(val).toFixed(2);
    return val;
  };

  useEffect(() => {
    if (!selectedCompetition || !selectedSchool) {
      navigate("/");
    } else {
      fetchData();
    }
  }, []);

  if (values.length === 0 && !isFetching) {
    return <p>{textIdentifier["no-data-found"][lang]}</p>;
  }

  return (
    <div className="cr-card sub-topic-wise-report">
      {/* Changes go here for School subjectwise report */}
      {
        !!values
        &&
        <SubjectwiseReport data={values} />
      }
      {/* {values.map((_, i) => (
        <div key={i} className="col">
          <h4>
            {i + 1}. {_.name}
          </h4>
          <ReportTable
            data={[
              [
                `${handleFloatParse(_.proficiency)}%`,
                `${handleFloatParse(_.accuracy)}%`,
                parseFloat(
                  _.easy_question_count +
                    _.medium_question_count +
                    _.hard_question_count
                ).toFixed(2),
                handleFloatParse(_.marks),
              ],
              [
                <ScoreView
                  content={`Overall proficiency ${_.competition_proficiency}%`}
                >
                  <div>
                    <Notation status={_.proficiency_status} />
                  </div>
                </ScoreView>,
                <ScoreView
                  content={`Overall accuracy ${_.competition_accuracy}%`}
                >
                  <div>
                    <Notation status={_.accuracy_status} />
                  </div>
                </ScoreView>,
                `(E${handleFloatParse(
                  _.easy_question_count
                )}, M${handleFloatParse(
                  _.medium_question_count
                )}, H${handleFloatParse(_.hard_question_count)})`,
                <ScoreView content={`Overall marks ${_.competition_marks}`}>
                  <div>
                    <Notation status={_.proficiency_status} />
                  </div>
                </ScoreView>,
              ],
            ]}
            headers={[["Proficiency", "Accuracy", "Question Count", "Marks"]]}
          />
        </div>
      ))} */}
    </div>
  );
}
